import { StatusInfo } from "../common/Status";
import { ProductStatus } from "./types";

export function getProductStatusInfo(status: ProductStatus): StatusInfo {
	const map: Record<ProductStatus, StatusInfo> = {
		ACTIVE: { text: 'Activo', class: 'success' },
		INACTIVE: { text: 'Inactivo', class: 'danger' },
		ARCHIVED: { text: 'Archivado', class: 'secondary' },
		DRAFT: { text: 'Borrador', class: 'secondary' },
	};

	return map[status] ?? { text: String(status), class: 'secondary' };
}